<style scoped>
  .btn-width {
    width: 80px;
  }
  .button-item{
    width: 260px;
    margin-bottom: 3px;
  }
  .button-large{
    width: 100%;
    /* margin-bottom: 3px; */
  }
  .row {
    margin-bottom: 5px !important;
  }
</style>


<template>
  <ModalHolder m-top="55" :title="''" :is-show="showModal" :mWidth="'90%'"
    :mHeight="'50vh'" :closable="false"
    @on-close="modalHide()">
    <template slot="mheader">
      <div class="flex-container direction-row center" style="justify-content:space-between;">
        <div></div>
        <b>Report this {{ itemtype.replace('activity','post') }}?</b>
        <img alt=" " @click="modalHide()" style="height:25px; width:25px;" src="@/assets/close.png">
      </div>
    </template>
    <template slot="mcontent">
      <Row>
        <!-- <RadioGroup v-model="whyDefault" vertical  @on-change="clickWhy">
          <Radio :label="why.id" v-for="(why,iwhy) in reportCategory" :key="iwhy">
              {{ why.label }}
          </Radio>
        </RadioGroup> -->
        <RadioGroup v-model="reportSelected" vertical v-for="(report, ireport) in reportCategory" :key="ireport">
          <Radio :label="report.value">&nbsp; {{ report.label }} </Radio>
        </RadioGroup>
        <textarea ref="reason" v-model="reason" id="reason" placeholder="Write something..." cols="30" rows="3" class="ivu-input button-item" style="margin-top:5px;width:100%;"></textarea>
      </Row>
    </template>
    <template slot="mfooter">
      <div style="text-align:center; width:100% !important;">
        <ButtonGroup vertical style="width:100% !important;">
          <Row class="row">
            <Button v-if="isLoadingReporting" class="button-large" type="primary" loading disabled>Reporting...</Button>
            <Button v-else class="button-large" type="primary" @click="submit()">Submit</Button>
          </Row>
        </ButtonGroup>
      </div>
    </template>
  </ModalHolder>
</template>


<script>
import _ from "lodash";
import Vue from 'vue';
import ModalHolder from "@/components/ModalHolderComponent";

export default {
  name: 'ReportComponent',
  components: {
    ModalHolder
  },
  props: {
    itemtype: {
      type: String,
      required: true
    },
    activityid: {
      type: String,
      required: false
    },
    userid: {
      type: String,
      required: false
    },
    commentid: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      forceShowModal: false,
      hasReason: false,
      whyDefault: 1,
      currentStep:0,
      reason: '',
      reportSelected: ''
    }
  },
  mounted() {
    // this.$store.commit('user/setLoadingReporting', false);
    // this.$store.dispatch('user/reportCategory').then(
    //   res=>{
    //     this.reportSelected=this.reportCategory[0].label;
    //   }
    // );
    
    setTimeout(()=> {
      if (this.reportCategory[0]) this.reportSelected=this.reportCategory[0].label;
    },2000);
  },
  watch: {
    reason: function() {
      this.hasReason = false;
      if (this.reason!=undefined) {
        this.hasReason = this.reason.trim().length>0;
      }
    }
  },
  computed: {
    reportCategory: function() {
      return _.orderBy(this.$store.state.user.reportCategory.data.choices, ['created_at'],['asc']);
    },
    isLoadingReporting: function() {
      return this.$store.state.user.isLoadingReporting;
    },
    careplan: function() {
      var plan = this.$store.state.resource.singleResource.data;
      return plan;
    },
    showModal: function() {
      var modal = (this.$store.state.user.showStepsUser && this.itemtype==='user') ||
                  (this.$store.state.user.showStepsActivity && this.itemtype==='activity') ||
                  (this.$store.state.user.showStepsComment && this.itemtype==='comment');
      return modal;
    }
  },
  methods: {
    clickWhy: function(v) {
      this.report.why = this.whys[v-1];
      // if (this.report.why.id!=5) {
      //   this.reason="";
      // } else if (this.report.why.id==5) {
      //   this.$refs.reason.focus();
      // }
    },
    clickReason: function(v) {
      this.report.reason = v;
      this.reason="";
    },
    reasonOnFocus: function() {
      this.whyDefault=5;
      this.report.reason=this.reasons[5];
    },
    next: function() {
      this.currentStep++;
      if (this.currentStep==1) {
        this.$refs.reason.focus();
      }
    },
    modalHide: function() {
      if (this.itemtype=='user') {
        this.$store.commit('user/setShowStepsUser', false);
      } else if (this.itemtype=='activity') {
        this.$store.commit('user/setShowStepsActivity', false);
      } else if (this.itemtype=='comment') {
        this.$store.commit('user/setShowStepsComment', false);
      }
      this.currentStep=0;
      this.reportSelected='';
      this.reason = "";      
    },
    submit: function() {
      var param = {
        type: 'moderation',
        data: {
          report_type: this.reportSelected,
          text: this.reason,
          item_type: this.itemtype,
          item_id: this.$store.state.user.reportThisId
        }
      };      
      
      this.$store.dispatch('user/reporting', param).then(
        res=> {
          console.log("reportConcern success...", res);
          this.modalHide();

          this.$Message({
            closable: true,
            title: { content:'Submitted!' },
            icon: 'checkmark',
            message: { content: 'The '+ this.itemtype.replace('activity','post') +' was submitted and it will be reviewed by our admin.' },
            buttons: [
              { label: 'Ok', type: 'success', hideAfter:true, action: ()=> {} }
            ]
          });             

        },
        err=> {
          console.log("there was an error...", [err]);
        }
      );
    }
  }

}

</script>
